const stagingHosts = [
  'register-dev.guestyforhosts.com',
  'register-staging.guestyforhosts.com',
  'localhost',
];

const prodHosts = ['start.guestyforhosts.com', 'hosts.guesty.com'];

const getEnv = (host) => {
  if (prodHosts.includes(host)) {
    return 'production';
  }

  if (stagingHosts.includes(host)) {
    return 'staging';
  }

  return 'staging';
};

const env = getEnv(window.location.host);

export default env;
